import React from 'react';
import Dotdotdot from 'react-dotdotdot';

import Link from '../../../shared/components/hyperlink'
import AdaptiveImage from '../../../shared/components/adaptive-image'
import Button from '../../../ui/components/button';

import './css/blog-cell.less';

const BlogCell = (props) => {

  let { slug, blogDate, blogTitle, thumbnail:image } = props;

  let d = new Date(blogDate);
  const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

  let date = monthNames[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();

  if(typeof image === "string") {
    image = {
      src: image,
      alt: 'HPImage',
      title: 'HPImage',
    }
  }
  else if(Array.isArray(image)) {
    image = {
      src: image[0],
      alt: 'HPImage',
      title: 'HPImage',
    }
  }
  else if(!image) {
    image = {
      src: null,
      alt: 'HPImage',
      title: 'HPImage',
    }
  }

  return (
      <div className="blog-cell">
        <Link to={`/${slug}`}>
            <div className="blog-cell-thumbnail">
                <AdaptiveImage
                    className="blog-cell-thumbnail-image"
                    src={image.src}
                    alt={image.alt}
                    title={image.title}
                    lazyload={true}
                    maxWidth={500}
                />
            </div>
            <div className="blog-cell-title">
              <Dotdotdot clamp={2}>{blogTitle}</Dotdotdot>
            </div>
            <div style={{textAlign: "left"}}>
              <div className="blog-cell-date">{date}</div>
              <Button color="dark" className="blog-read-more" text="READ MORE" action="go"/>
            </div>
        </Link>
      </div>
  );
}

export default React.memo(BlogCell);
